// tslint:disable
/* MACLE TypeScript 23/01/2026 00:31:27 */
import { DataLiquidacaoParcelaAPP, PKLiquidacaoParcelaAPP, FilterLiquidacaoAPP } from '../vo/sitevo.vo';
import { BaseVO } from '../vo/maf.vo';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { BaseService, AjaxService, IModelServiceResponse, Parser, ArrayList } from 'maf-web';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class LiquidacaoParcelaModelService extends BaseService {
  private _url = 'liquidacaoparcelaService?action=';

  constructor(router: Router, ajax: AjaxService, private toastrService: ToastrService) {
    super(router, ajax, toastrService);
  }

  public add(vo: DataLiquidacaoParcelaAPP): Promise<PKLiquidacaoParcelaAPP> {
    let params = {
      "vo": vo
    };
    return this.ajax.post(this._url + 'add', params)
      .then((r: IModelServiceResponse<PKLiquidacaoParcelaAPP>) => Parser.jsonToClass(r.value, PKLiquidacaoParcelaAPP))
      .catch((error: any) => this.handleError(error));
  }

  public del(pk: PKLiquidacaoParcelaAPP): Promise<boolean> {
    let params = {
      "pk": pk
    };
    return this.ajax.post(this._url + 'del', params)
      .then((r: IModelServiceResponse<string>) => r.value === "OK")
      .catch((error: any) => this.handleError(error));
  }

  public getCount(filter: FilterLiquidacaoAPP): Promise<number> {
    let params = {
      "filter": filter
    };
    return this.ajax.post(this._url + 'getCount', params)
      .then((r: IModelServiceResponse<number>) => r.value)
      .catch((error: any) => this.handleError(error));
  }

  public exists(pk: PKLiquidacaoParcelaAPP): Promise<boolean> {
    let params = {
      "pk": pk
    };
    return this.ajax.post(this._url + 'exists', params)
      .then((r: IModelServiceResponse<boolean>) => r.value)
      .catch((error: any) => this.handleError(error));
  }

  public getData(pk: PKLiquidacaoParcelaAPP): Promise<DataLiquidacaoParcelaAPP> {
    let params = {
      "pk": pk
    };
    return this.ajax.post(this._url + 'getData', params)
      .then((r: IModelServiceResponse<DataLiquidacaoParcelaAPP>) => Parser.jsonToClass(r.value, DataLiquidacaoParcelaAPP))
      .catch((error: any) => this.handleError(error));
  }

  public isPixPagoLiquidacaoParcela(pk: PKLiquidacaoParcelaAPP): Promise<boolean> {
    let params = {
      "pk": pk
    };
    return this.ajax.post(this._url + 'isPixPagoLiquidacaoParcela', params)
      .then((r: IModelServiceResponse<boolean>) => r.value)
      .catch((error: any) => this.handleError(error));
  }

  public getList(filter: BaseVO): Promise<DataLiquidacaoParcelaAPP[]> {
    let params = {
      "filter": filter
    };
    return this.ajax.post(this._url + 'getList', params)
      .then((r: IModelServiceResponse<ArrayList<DataLiquidacaoParcelaAPP>>) => Parser.jsonToClass(r.value, DataLiquidacaoParcelaAPP))
      .catch((error: any) => this.handleError(error));
  }

  public edit(vo: DataLiquidacaoParcelaAPP): Promise<boolean> {
    let params = {
      "vo": vo
    };
    return this.ajax.post(this._url + 'edit', params)
      .then((r: IModelServiceResponse<string>) => r.value === "OK")
      .catch((error: any) => this.handleError(error));
  }

  public getPage(filter: FilterLiquidacaoAPP, PageIdx: number, NumRecInPage: number): Promise<DataLiquidacaoParcelaAPP[]> {
    let params = {
      "filter": filter,
      "PageIdx": PageIdx,
      "NumRecInPage": NumRecInPage
    };
    return this.ajax.post(this._url + 'getPage', params)
      .then((r: IModelServiceResponse<ArrayList<DataLiquidacaoParcelaAPP>>) => Parser.jsonToClass(r.value, DataLiquidacaoParcelaAPP))
      .catch((error: any) => this.handleError(error));
  }

}


